export { default } from './PagePersonalDetail'
